import { Card, CardBody } from '@vnetwork/ui/primitives';
import { InfoGrid } from '@/pages/account/components/InfoGrid';
import type { EmployeeRecord } from '@/api/employees';

interface Props { emp: EmployeeRecord }

/**
 * Address tab — permanent address (country / city / district / ward / street)
 * and temporary address. Matches the legacy Update/TabComponents/Address panel.
 */
export function EmployeeTabAddress({ emp }: Props) {
  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
      <Card flat>
        <CardBody>
          <p style={{
            margin: '0 0 var(--vn-space-3)',
            fontSize: 'var(--vn-font-size-sm)',
            fontWeight: 'var(--vn-font-weight-semibold)',
            color: 'var(--vn-fg-default)',
          }}>
            Permanent address
          </p>
          <InfoGrid
            items={[
              { label: 'Country', value: emp.employee_country },
              { label: 'City', value: emp.employee_city },
              { label: 'District', value: emp.employee_district },
              { label: 'Ward', value: emp.employee_ward },
              { label: 'Street', value: emp.employee_street, full: true },
            ]}
          />
        </CardBody>
      </Card>

      <Card flat>
        <CardBody>
          <p style={{
            margin: '0 0 var(--vn-space-3)',
            fontSize: 'var(--vn-font-size-sm)',
            fontWeight: 'var(--vn-font-weight-semibold)',
            color: 'var(--vn-fg-default)',
          }}>
            Temporary address
          </p>
          <InfoGrid
            items={[
              { label: 'City', value: emp.employee_temporary_city },
              { label: 'District', value: emp.employee_temporary_district },
              { label: 'Ward', value: emp.employee_temporary_ward },
              { label: 'Street', value: emp.employee_temporary_street, full: true },
            ]}
          />
        </CardBody>
      </Card>
    </div>
  );
}
